import { inject, Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { TenantComponentsRestApi } from '../../../infrastructure/api/tenant-components-rest.api';
import { UpdateTenantComponentsCommand } from './update-tenant-components.command';

export interface UpdateTenantComponentsResult {
  success: boolean;
  error?: string;
}

@Injectable()
export class UpdateTenantComponentsUseCase {
  private readonly _api = inject(TenantComponentsRestApi);

  public execute(command: UpdateTenantComponentsCommand): Observable<UpdateTenantComponentsResult> {
    return this._api
      .updateComponents({
        sharedServicesPortalEnabled: command.sharedServicesPortalEnabled,
        employeeRelationsPortalEnabled: command.employeeRelationsPortalEnabled,
      })
      .pipe(
        map(() => ({ success: true })),
        catchError((error: { message?: string }) =>
          of({ success: false, error: error.message ?? 'Unknown error' }),
        ),
      );
  }
}
